import keyBy from "lodash/keyBy";
import { normalizeWidgetPositions } from "views/logic/widgets/normalizeWidgetPositions";
const normalizeViewState = (viewState) => {
  const { widgetPositions, widgets } = viewState;
  const widgetById = keyBy(widgets.toArray(), "id");
  const normalizedWidgetPositions = normalizeWidgetPositions(widgetPositions, widgetById);
  return viewState.toBuilder().widgetPositions(normalizedWidgetPositions).build();
};
export default normalizeViewState;
